import { Body, Controller, Post } from '@nestjs/common';
import { Cron } from '@nestjs/schedule';
import { ApiBody } from '@nestjs/swagger';
import { ErrorResponse } from '@shahi-analytics/backend-utils';
import { GlobalResponseObject } from '@shahi-analytics/shared-models';
import { GtsMigrationService } from './migration.service';
import { UnitDayHourMinuteRequest } from './models/unit-day-hour-minute.request';
import { GtsMigrationHelperService } from './migration-helper.service';
import { GtsAppTableNamesEnum } from '../gts/models/app-table-names.enum';
import axios  from 'axios';

@Controller('gts')
export class GtsMigrationController {
  constructor(
      private readonly gtsService: GtsMigrationService,
      private gtsMigHelperService: GtsMigrationHelperService
    ) { }

  // Trigger this for every 1 hour at the 2nd minute of the hour
  // @Cron('0 2 * * * *')
  async tiriggerUnitLevelMigration(): Promise<boolean> {
    const units = await this.gtsMigHelperService.getActiveUnits();
    for(const unit of units) {
      const req = new UnitDayHourMinuteRequest();
      req.unit = unit.unitId;
      await this.callLineHourMigraiton(req);
    }
    return true;
  }

  @Post('/callLineHourMigraiton')
  async callLineHourMigraiton(@Body() req: UnitDayHourMinuteRequest) {
    console.log('Job execution started');
    const unitRec = await this.gtsMigHelperService.getUnitRecord(req.unit);
    let hours: string[] = unitRec?.workingHours?.split(',');
    if(hours?.length == 0) {
      return new ErrorResponse(0, 'Working hours not defined for the plant : '+req.unit);
    }
    let date = new Date();
    const currentDate = date.toJSON().slice(0, 10);
    const hour = date.getHours() - 1; // -1 beacuse we have to sync data for the pre hour when the job runs in the current hour
    if(!hours.includes(hour.toString())) {
      return new ErrorResponse(0, 'Should not run at plant closing hours');
    }
    const migReq = new UnitDayHourMinuteRequest();
    migReq.unit = req.unit;
    migReq.date = currentDate;
    migReq.hour = hour;
    migReq.ntd = false;
    console.log(migReq);
    this.createPoAndPoLines(migReq);
  }

  // @Cron('*/15 * * * *')
  async tiriggerUnitLevelFailedMigration(): Promise<boolean> {
    const units = await this.gtsMigHelperService.getActiveUnits();
    for(const unit of units) {
      const req = new UnitDayHourMinuteRequest();
      req.unit = unit.unitId;
      await this.callFailedMigration(req);
    }
    return true;
  }

  // @Cron('*/15 * * * *')
  @Post('/callFailedMigration')
  async callFailedMigration(@Body() req: UnitDayHourMinuteRequest) {
    console.log('Job re execution started');
    const unitRec = await this.gtsMigHelperService.getUnitRecord(req.unit);
    let hours: string[] = unitRec?.workingHours?.split(',');
    if(hours?.length == 0) {
      return new ErrorResponse(0, 'Working hours not defined for the plant : '+req.unit);
    }
    let date = new Date();
    const currentDate = date.toJSON().slice(0, 10);
    const hour = date.getHours() - 1; 
    if(!hours.includes(hour.toString())) {
      throw new ErrorResponse(0, 'Should not run at plant closing hours');
    }
    // only execute only for if the current minute is after a certain timeperiod of the parent job
    if(date.getMinutes() > 14 && date.getMinutes() < 55) {
      // const recordExist = await this.gtsMigHelperService.checkIfDataDumpedForADateAndHour(currentDate, hour, '23');
      // Checking PO is enought because the transactional records are saved after the PO records are saved.
      const recordExist = await this.gtsMigHelperService.checkIfMigrationIsDoneForTableDateAndHour(currentDate, hour, req.unit, GtsAppTableNamesEnum.M_PO);
      if(!recordExist) {
        const migRe = new UnitDayHourMinuteRequest();
        migRe.unit = req.unit;
        migRe.date = currentDate;
        migRe.hour = hour;
        migRe.ntd = false;
        this.createPoAndPoLines(migRe);
      }
    }    
  }



  @ApiBody({type: UnitDayHourMinuteRequest})
  @Post('/createPoAndPoLines')
  async createPoAndPoLines(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.gtsService.createPoAndPoLines(req.unit, req.date, req.hour, req.ntd, req.fromMinute, req.toMinute);
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  @ApiBody({type: UnitDayHourMinuteRequest})
  @Post('/createTransactions')
  async createTransactions(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.gtsService.createTransactions(req.unit, req.date, req.hour, req.fromMinute, req.toMinute);
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  @ApiBody({type: UnitDayHourMinuteRequest})
  @Post('/createOperations')
  async createOperations(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.gtsService.createOperations(req.unit, req.date, req.hour);
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  @ApiBody({type: UnitDayHourMinuteRequest})
  @Post('/createStylesOps')
  async createStylesOps(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.gtsService.createStylesOps(req.unit);
    } catch(error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  @Post('/manualCall')
  async manualCall(): Promise<any> {
    var moment = require('moment');
    var a = moment('2023-10-01');
    var b = moment('2024-05-01');
    for (var m = moment(a); m.isBefore(b); m.add(1, 'days')) {

      const prom = new Promise(async (resolve, reject) => {
        // console.log(m.format('YYYY-MM-DD'));
        const date = m.format('YYYY-MM-DD');
        // http://172.20.50.169:3007
        await axios.post('http://172.20.50.169:3007/gts/createPoAndPoLines', {
          "unit": "54",
          "date": `${date}`,
          "hour": 0,
          "fromMinute": "",
          "toMinute": ""
        }).then(res => {
          resolve(1);
          // console.log(res);
          // console.log(`Response for : ${date} ` + res?.data);
          return;
        });
      });
      await prom.then(res => {

      });
    }
    return "DONE";
  }
}